module.exports = __webpack_public_path__ + "static/media/content-less-thin-24-blue.755b941c.svg";